import { addToast } from "components/ToastContainer/ToastStore";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "slice";
import {
    useChangePasswordMutation,
    useDeleteUserAccountMutation,
} from "slice/common/index";
import { ApiError } from "slice/jobs/types";
type SettingsFields = {
    current_password: string;
    new_password: string;
    password_confirmation: string;
};
export const useSetting = () => {
    const { id } = useAppSelector((state) => state.user);
    const navigateTo = useNavigate();
    const { userId } = useParams();
    const [isModalOpen, setModalOpen] = useState(false);

    const [deleteUserAccount, { isLoading: isDeleting, isSuccess, isError }] =
        useDeleteUserAccountMutation();

    const [changePassword, { isLoading: isChangePasswordLoading }] =
        useChangePasswordMutation();

    const handleDeleteAccount = async () => {
        try {
            await deleteUserAccount(id || "");
            window.location.reload();
            console.log("Account deleted successfully");
        } catch (error) {
            console.error("Error deleting account:", error);
        }
    };

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleSubmit = async (values: SettingsFields) => {
        try {
            const response = await changePassword({
                user_id: id || "",
                ...values,
            });
            if ((response as ApiError).error) {
                addToast({
                    type: "error",
                    text: (response as ApiError).error?.data.errors[0],
                    timer: 3000,
                });
            } else {
                addToast({
                    type: "success",
                    text: "Password changed successfully",
                    timer: 3000,
                });
                navigateTo("/");
            }
        } catch (error) {
            console.error("Error changing password:", error);
        }
    };
    return {
        userId,
        handleDeleteAccount,
        isDeleting,
        isSuccess,
        isError,
        isModalOpen,
        handleOpenModal,
        handleCloseModal,
        handleSubmit,
        isChangePasswordLoading,
    };
};
